export default {
  //fields: 'Id',
  filters: [],
  navs: [],
  messages: {
    noProducts: "Your search criteria has resulted in no products",
  },
  hideEmptyGroupings: false,
  hideGroupingCounts: false,
  maxPanelHeight: "188px",
  panelType: "default",
  hideLeftNav: false,
  useTitleCase: false,
  appendPageSize: 96,
  hideExport: false,
  hideExportRetailer: false,
  clearUserSettings: false,
  hydrateTagCriteria: false,
  retainQueryStringHistory: false,
  filterPromptDefaults: {
    size: "sm filters",
    backdrop: true,
    placement: "right",
    preventAutoHeight: true,
    title: ` `,
  },
  orderByOnSearch: false,
};
